module.exports = __webpack_public_path__ + "static/media/goal-tln-top10.6fecdada.png";